<template>
    <div @click="onClick" class="article-carousel-item-root clickable">
        <img :src="img" height="200" style="object-fit: cover;" />
        <div class="overlay" style="font-size: 10px; line-height: 40px;">
            <h6 class="px-3 py-3 mb-0 text-left font-weight-bold white">
                {{ title }}
            </h6>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Articles.CarouselItem',
    props: {
        title: String,
        img: String,
        click: Function,
    },
    methods: {
        onClick(e) {
            this.$emit('click');
            if (this.click) {
                this.click(e);
            }
        },
    },
};
</script>

<style lang="css" scoped>
.article-carousel-item-root {
    position: relative;
}

.article-carousel-item-root:hover > img {
    transform: scale(1.04);
}

.overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.55);
    color: white;
    box-shadow: 0px -2px 3px 0px rgba(0,0,0,0.75);
}

.article-carousel-item-root > img {
    width: 100%;
    object-fit: cover;
    transition: transform .2s; /* Animation */
}
</style>
